import React from "react";
import "./contact.css";
import { BiMailSend } from "react-icons/bi";

function Contatos() {
  return (
    <section className="contact section" id="contatos">
      <h2 className="section__title">Entrar em contato!</h2>
      <span className="section__subtitle">Me contate</span>

      <div className="contact__container container grid">
        <div className="contact__content">
          <h3 className="contact__title">Fale comigo</h3>

          <div className="contact__info">
            <div className="contact__card">
              <h3 className="contact__card-title">Email</h3>
              <span className="contact__card-data">
                contatomwinformatica@gmail.com
              </span>
              <a
                href="mailto:contatomwinformatica@gmail.com"
                className="contact__button"
              >
                Escreva um email!{" "}
              </a>
            </div>

            <div className="contact__card">
              <h3 className="contact__card-title">WhatsApp</h3>
              <span className="contact__card-data">553134183622</span>
              <a
                href="https://api.whatsapp.com/send?phone=553134183622&text=Olá, gostaria de falar contigo!"
                className="contact__button"
              >
                Fale via WhatsApp!{" "}
              </a>
            </div>
          </div>
        </div>

        <div className="contact__content">
          <h3 className="contact__title">Escreva para mim</h3>

          <form className="contact__form">
            <div className="contact__form-div">
              <label className="contact__form-tag">Nome</label>
              <input
                type="text"
                className="contact__form-input"
                placeholder="Insira seu nome"
                name="name"
              />
            </div>

            <div className="contact__form-div">
              <label className="contact__form-tag">Email</label>
              <input
                type="email"
                className="contact__form-input"
                placeholder="Insira seu email"
                name="email"
              />
            </div>

            <div className="contact__form-div contact__form-area">
              <label className="contact__form-tag">Mensagem</label>
              <textarea
                name="message"
                cols="30"
                rows="10"
                className="contact__form-input"
                placeholder="Escreva a sua mensagem"
              ></textarea>
            </div>

            <button className="button button--flex">
              Enviar Mensagem
              <BiMailSend className="button__icon" />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contatos;
